import React, { useEffect } from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { headApi, credentials } from "utils/headApi";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Mail from "@material-ui/icons/Mail";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
// import CustomInput from "components/CustomInput/CustomInput.js";
import SearchIcon from "@material-ui/icons/Search";
import Header from "views/Main/MainHeader.js";
import Footer from "views/Main/MainFooter.js";
// import MenuItem from "@material-ui/core/MenuItem";
// import Select from "@material-ui/core/Select";
import Selects from "react-select";
// import InputLabel from "@material-ui/core/InputLabel";
// import FormControl from "@material-ui/core/FormControl";
import AppCard from "./AppCard";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/preFooter.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";

import bg7 from "assets/img/bg7.jpg";

const useStyle = makeStyles(styles);
const useStyles = makeStyles(headersStyle);

export default function App() {
  const [stateItem, setStateItem] = React.useState([]);
  const [catItem, setCatItem] = React.useState([]);
  const [sizeItem, setSizeItem] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [category, setCategory] = React.useState("");
  const [sizeMM, setSizeMM] = React.useState("");

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();

  const options = [
    { value: "mumbai", label: "Mumbai" },
    { value: "karnataka", label: "Karnataka" },
    { value: "hyderabad", label: "Hyderabad" },
  ];

  async function getProdSEO() {
    const results = await fetch(headApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const res = await results.json();

    setStateItem(res);
    setStateList(res.map((f) => f.state));

    axios
      .get(headApi + `/admin/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        setCompanyList(res.data.AdminList.map((f) => f.company));
      });

    axios
      .get(headApi + `/category/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const items = res.data.map((f) => f.title);
        const uniqueItems = items.filter(
          (item, index, self) =>
            index === self.findIndex((i) => i.toLowerCase() === item.toLowerCase())
        );
        setCategoryList(uniqueItems);
      });

    axios
      .get(headApi + `/parent/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const itemss = res.data.map((f) => f.title);
        const uniqueItemss = itemss.filter(
          (item, index, self) =>
            index === self.findIndex((i) => i.toLowerCase() === item.toLowerCase())
        );
        setParentList(uniqueItemss);
      });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  const handleStateOption = (selectedOption) => {
    setSelectedOption(selectedOption);

    axios
      .get(headApi + `/product/findByProductCategory/${selectedOption.value}`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        // console.log(res.data);
        
        // const mergedCategories = Array.from(
        //   new Map(
        //     res.data.ProductCategoryList.map((c) => [
        //       c.categoryTitle.toLowerCase(),
        //       { ...c, categoryTitle: c.categoryTitle.toUpperCase() },
        //     ])
        //   ).values()
        // );
        // console.log(mergedCategories);
        

        setCatItem( res.data.ProductCategoryList);
        setCategoryList(res.data.ProductCategoryList.map((f) => f.categoryTitle));
      });
  };

  const handleCategory = (category) => {
    axios
      .get(headApi + `/product/findByCategoryParent/${category.value}`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const uniqueData = res.data.ProductParentList.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.parentTitle === obj.parentTitle)
        );
        setSizeItem(uniqueData);
        setParentList(res.data.ProductParentList.map((f) => f.parentTitle));
      });

    setCategory(category);
  };

  const handleSearch = () => {
    if (category) {
      history.push(
        `/search?category=${category?.value}&catSize=${sizeMM?.value}&country=India&state=${selectedOption?.value}`
      );
    } else {
      alert("Enter text to Search");
    }
  };

  // useEffect(() => {
  //   if(category.value == "BANGLES"){
  //     setSizeItem("")
  //   }
  // },[category])

  return (
    <div className="cd-section">
      <Helmet>
        <title>B2B</title>
        <meta name="description" content="Best B2B Comapnay" />
        <meta
          name="keywords"
          content={`${categoryList},${parentList},${stateList},${companyList}`}
        />
        <meta name="keywords" content="Shaikh Toufiq" />
        {/*<meta name="keywords" content="Andhra Pradesh, Arunachal Pradesh, Assam, Bihar, Chhattisgarh, Goa, Gujarat, Haryana, Himachal Pradesh, Jharkhand, Karnataka, Kerala, Madhya Pradesh, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Odisha, Punjab, Rajasthan, Sikkim, Tamil Nadu, Telangana, Tripura, Uttar Pradesh, Uttarakhand, West Bengal" /> */}
      </Helmet>
      <div>
        <Header
          absolute
          // fixed
          brand="Home"
          color="transparent"
          links={
            <div className={classes.collapse}>
              <List className={classes.list + " " + classes.mlAuto}>
                <ListItem className={classes.listItem}>
                  <Button
                    className={classes.navLink}
                    onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Help
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    className={classes.navLink}
                    onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Message
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    className={classes.navLink}
                    onClick={(e) => e.preventDefault()}
                    color="transparent"
                  >
                    Sign In
                  </Button>
                </ListItem>
              </List>
            </div>
          }
        />
        <div
          className={classNames(
            classe.subscribeLine,
            classe.subscribeLineImage
          )}
          style={{ backgroundImage: `url(${bg7})` }}
        >
          <div className={classe.container}>
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={8}
                className={classNames(classe.mlAuto, classe.mrAuto)}
              >
                <div className={classe.textCenter} style={{ marginTop: "20%" }}>
                  <h3 className={classe.title}>B2B INDIAN BANGLES</h3>
                  <p className={classe.description}>
                    Join our newsletter and get news in your inbox every week!
                    We hate spam too, so no worries about this.
                  </p>
                </div>
                <Card raised className={classe.card}>
                  <CardBody className={classe.cardBody}>
                    <form>
                      <GridContainer>
                        <GridItem
                          xs={12}
                          sm={4}
                          md={4}
                          lg={4}
                          style={{ marginTop: "1%" }}
                        >
                          <Selects
                            value={selectedOption}
                            placeholder="All India..."
                            onChange={handleStateOption}
                            // onChange={setSelectedOption}
                            // options={options}
                            options={
                              stateItem &&
                              stateItem.map((s) => {
                                return {
                                  label: s.state,
                                  value: s.state,
                                };
                              })
                            }
                          />
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ marginTop: "1%" }}
                        >
                          <Selects
                            value={category}
                            placeholder="Category..."
                            onChange={handleCategory}
                            // options={options}
                            options={
                              catItem &&
                              catItem.map((c) => {
                                return {
                                  label: c.categoryTitle,
                                  value: c.categoryTitle,
                                };
                              })
                            }
                          />
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={3}
                          md={3}
                          lg={3}
                          style={{ marginTop: "1%" }}
                        >
                          <Selects
                            value={sizeMM}
                            placeholder="SizeMM..."
                            onChange={setSizeMM}
                            // options={options}
                            options={
                              sizeItem &&
                              sizeItem.map((s) => {
                                return {
                                  label: s.parentTitle,
                                  value: s.parentTitle,
                                };
                              })
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={2} md={2} lg={2}>
                          <Button
                            color="primary"
                            block
                            className={classe.subscribeButton}
                            onClick={handleSearch}
                          >
                            <SearchIcon /> search
                          </Button>
                        </GridItem>
                      </GridContainer>
                    </form>
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <div className={classNames(classe.main, classe.mainRaised)}>
        <div className={classe.container}>
          <br />
          <AppCard />
        </div>
      </div>
      <Footer />
    </div>
  );
}
